import { aboveBreakpoint, appendPx, belowBreakpointOrEqual, Button, fadeColor, fromThemeCreator, getColor, keyframes, lightenColor, styled } from 'imaginarity-react-ui';
import { globalSettings } from 'services/Config';
import { SidebarContainerContent } from 'views/CustomSC';
import { WikiTheme } from './WikiTheme';

const fromTheme = fromThemeCreator<WikiTheme>("wikiTheme");

const flyIn = keyframes`
  from {
    transform: translateX(-50%) translateY(-1000px) scaleY(2.5) scaleX(0.2);
    filter: blur(40px);
    opacity: 0;
  }
  to {
    transform: translateX(-50%) translateY(-50%) scaleY(1) scaleX(1);
    filter: blur(0);
    opacity: 1;
  }
`;

const pulsate = keyframes`
  from {
    transform: translateX(-1000px) scaleX(2.5) scaleY(0.2);
    transform-origin: 100% 50%;
    filter: blur(40px);
    opacity: 0;
  }
  to {
    transform: translateX(10px) scaleY(1) scaleX(1);
    transform-origin: 50% 50%;
    filter: blur(0);
    opacity: 1;    
  }
`;

const flicker = keyframes`
  0%{
    opacity: 1;
  }
  41% {
    opacity: 1;
  }
  42% {
    opacity: 0;
  }
  43% {
    opacity: 0;
  }
  44% {
    opacity: 1;
  }
  48% {
    opacity: 1;
  }
  49% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  51% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
`;



export class WikiSC {
    public static WikiArticleTOCContainer = styled.div`
    margin: 40px 0 -40px 0;
`;
    public static TableOfContentContainer = styled.div<{ isTablet: boolean, isMobile: boolean }>`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 1fr;
    grid-template-columns: 1fr;
    -ms-grid-rows: auto;
    grid-template-rows: min-content;
    grid-gap: 0px;
    padding: 5px 0px 10px ${p => p.isMobile ? 10 : p.isTablet ? 0 : 0}px;
`;
    public static CommentsRatingsImplementations = styled.div`
    display: grid;
    display: -ms-grid;
    grid-template-columns: 1fr 1fr 1fr;
    -ms-grid-columns: 1fr 1fr 1fr;
    margin-top: 10px;
`;
    public static CommentsContainer = styled.div`
    grid-column-start: 1;
    -ms-grid-column: 1;
    grid-column: 1;
    -ms-grid-column-span: 3;
    grid-column-end: 4;
    background: ${p => getColor(p, p.theme.colors.veryLightGrey)};
`;
    public static CommentsRatingsImplementationsContent = styled.div`
    grid-row: 2;
    -ms-grid-row: 2;
    grid-column: 1 / span 3;
    -ms-grid-column: 1 / span 3;
    border: 1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
    margin-bottom:30px;
    margin-top:-1px;
`;
    public static BannerContainer = styled.div<{ imageUrl: string, revMode?: boolean }>`
    /* width: calc(110% + 20px);
    margin-left: calc(-5% - 10px); */
    width: 111.12%;
    margin-left:-5.56%;
    //height: calc(${props => props.theme.content.width}px * 3 / 7);
    height: ${p => p.revMode ? "40px" : `calc(${p.theme.content.width}px * 3 / 7)`};
    //padding-bottom: ${p => 100 / 7 * 3}%;
    padding-bottom: ${p => p.revMode ? "40px" : `${100 / 7 * 3}%`};
    background-image: url('${props => props.imageUrl ?? props.theme.emptyImageUrl}');
    background-size: cover;
    //background-position: center center;
    background-position: ${p => p.revMode ? "center bottom" : "center center"};
    background-repeat: no-repeat;
    position: relative;
    margin-top: -2px;
    transition: 0.2s all ease-in-out;
    button>div{margin: 0;}
    position: ${p => p.revMode ? "sticky" : "relative"};
    z-index: 10;
    top: 0px;
`;
    public static BannerTitleContainerBG = styled.div`
    position: absolute;
    bottom:0px;
    left:0px;
    width: 100%;
    height:60px;
    background: ${props => fadeColor(props, getColor(props, "@darkerGrey"), 50)};
`;
    public static BannerTitleRevBtnContainer = styled.div<{ revMode: boolean }>`
    position: sticky;
    /* width: ${p => p.revMode ? "calc(110% + 20px)" : "150px"};
    margin-left: ${p => p.revMode ? "calc(-5% - 10px)" : "calc(105% - 140px)"};   */
    width: ${p => p.revMode ? "111.12%" : "150px"};
    margin-left: ${p => p.revMode ? "-5.56%" : "calc(105.56% - 140px)"};  
    top: 0px;
    background: linear-gradient(to right, ${p => p.revMode ? "transparent" : "#323639"}, ${p => p.revMode ? getColor(p, "@accentLightBlue") : "#323639"} calc(100% - 140px));
    transition: 0.2s all ease-in-out;
    border-bottom-left-radius: ${p => p.revMode ? 0 : 8}px;
    overflow: hidden;
    z-index: 100;
    height: 40px;
    margin-bottom: -40px;
    button>div{
        transition: 0.2s all ease-in-out;
        margin: 0px;
        color: ${p => p.revMode ? getColor(p, "@mainBackground") : lightenColor(p, "@accentLightBlue", 120)};
        svg{
            transition: 0.2s all ease-in-out;
            stroke: ${p => p.revMode ? getColor(p, "@mainBackground") : lightenColor(p, "@accentLightBlue", 120)};
            transform: translateY(${p => p.revMode ? 0 : -2}px);
        }
    }
    
    &:hover{
        background: linear-gradient(to right, ${p => p.revMode ? "transparent" : "#323639"}, ${p => p.revMode ? getColor(p, "@accentLightBlue") : "#151718"});
        color: ${p => getColor(p, "@mainBackground")};
        button>div{
            color: ${p => getColor(p, "@mainBackground")};
            svg{
                stroke: ${p => getColor(p, "@mainBackground")};
            }
        }
    }
`;
    public static BannerTitle = styled.div<{ revMode?: boolean }>`
    position: absolute;
    bottom:0px;
    left: 0px;
    font-size:1.4rem;
    line-height: ${p => p.revMode ? 40 : 40}px;
    white-space: nowrap;
    width: calc(100% - 0px);                   
    overflow: hidden;   
    text-overflow: ellipsis;
    //background: ${props => fadeColor(props, getColor(props, props.theme.colors.accentBlack), 50)};
    padding: 0 calc(5% + 3px);
    color: ${props => getColor(props, fromTheme(props, t => t.categoryTheme.bannerOverlayTitleColor, t => t.colors.mainBackground))};
    transition: 0.2s all ease-in-out;
    svg{
        stroke: ${props => getColor(props, fromTheme(props, t => t.categoryTheme.bannerOverlayTitleColor, t => t.colors.mainBackground))};
    }
`;

    public static BannerRevisionInfo = styled.div`
    font-size: 1.4rem;
    color: ${props => getColor(props, "@accentLightBlue")}; 
    text-transform: uppercase;  
    font-weight: bolder;
    margin-bottom: -50px;
    margin-top: 20px;
    display: grid;
    grid-template-columns: max-content 1fr max-content;
    column-gap: 20px;
    height: 40px;
    line-height: 40px;
`;

    public static InfoEdit = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 40px;
    background: ${props => fadeColor(props, getColor(props, props.theme.colors.accentBlack), 70)};
    text-align: right;
    padding-right: 20px;
    line-height: 40px;
    border-top: 1px solid ${props => getColor(props, props.theme.colors.accent)};
`;
    public static BannerArticleVersion = styled.div<{ isMobile: boolean }>`
    position: absolute;
    top:${props => props.isMobile ? "20px" : "unset"};
    bottom:${props => props.isMobile ? "unset" : "5px"};
    left:${props => props.isMobile ? "20px" : "unset"};
    right:${props => props.isMobile ? "unset" : "calc(5% + 0px)"};
    font-size:0.7rem;
    height:30px;
    line-height:30px;
    padding: 0 10px;
    background: ${props => getColor(props, fromTheme(props, t => t.categoryTheme.bannerOverlayVersionBackgroundColor, t => t.colors.accent))};
    color: ${props => getColor(props, fromTheme(props, t => t.categoryTheme.bannerOverlayVersionFontColor, t => t.colors.mainForeground))};
    border: 1px solid ${props => lightenColor(props, fromTheme(props, t => t.categoryTheme.bannerOverlayVersionBackgroundColor, t => t.colors.mainBackground), 70)};
    z-index:3;
`;
    public static TableHeaderFontBold = styled.div`
    input{
        font-weight: bold;
    }
`;
    public static SectionTitle = styled.div<{ open: boolean, isLinkedSec: boolean, noTitle?: boolean }>`
    display: block;
    font-size:1.2rem;
    font-weight:bolder;
    line-height: 40px;
    min-height:40px;
    margin-bottom: ${p => p.noTitle ? -30 : 10}px;
    padding-top:30px;
    width: 100%;
    transition: 0.2s all ease-out;
    border-bottom: ${props => props.noTitle ? "none" : props.open ? "1px" : "0px"} solid rgba(0,0,0,0.05);
    color:${props => props.isLinkedSec ? getColor(props, "@accent") : props.open ? getColor(props, props.theme.colors.mainForeground) : getColor(props, props.theme.colors.lightGrey)};
    animation: ${p => p.isLinkedSec ? flicker : "none"} 1s linear 3s 3 both;
`;
    public static PulsateIcon = styled.div`
    animation: ${pulsate} 0.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) 3s both;
    margin-left: -30px;
    svg{
        stroke: ${props => getColor(props, props.theme.colors.accent)};
        }
`;

    public static AIHint = styled.div`
        color:  ${p => getColor(p, "@middleLightGrey")};
        float: right;
        letter-spacing: 0.2pt;
        font-size: 0.7em;
        font-weight: normal;
        text-transform: uppercase;
`;

    public static ColumnTitle = styled.div<{ isLinkedCol: boolean }>`
    font-size: 1.1rem;
    font-weight: bolder;
    line-height: 1.6rem;
    display: block;
    margin-bottom:5px;
    color: ${p => p.isLinkedCol ? getColor(p, p.theme.colors.accent) : "inherit"};
    animation: ${p => p.isLinkedCol ? flicker : "none"} 1s linear 3s 3 both;
`;

    public static ColumnTitleLabel = styled.div<{ large?: boolean, revMode?: boolean }>`
    border-right: 1px solid ${p => getColor(p, "@middleLightGrey")};
    background: ${p => p.revMode ? fadeColor(p, "@accentBlue", 10) : fadeColor(p, "@darkGrey", 5)};
    float: left;
    margin-right: 10px;
    width: 40px;
    height: ${p => p.large ? 40 : 30}px;
    text-align: center;
    margin-top: ${p => p.large ? 0 : 5}px;
    line-height: ${p => p.large ? 40 : 30}px;
`;

    public static RevisionContainer = styled.div<{ revisionMode: boolean, noHover: boolean, reviewed: boolean }>`
    border: ${p => (p.revisionMode) ? (p.noHover ? `1px solid ${getColor(p, "@darkGrey")}` : `1px solid ${getColor(p, "@middleLightGrey")}`) : "none"};
    background:  ${p => (p.revisionMode) ? (p.noHover ? getColor(p, "@veryLightGrey") : fadeColor(p, p.reviewed ? "@accentLightGreen" : "@accentLightBlue", p.reviewed ? 5 : 3)) : "transparent"};
    padding: ${p => (p.revisionMode) ? 5 : 0}px;
    transition: 0.2s all ease-in-out;
    margin-bottom: ${p => p.noHover ? 100 : (p.revisionMode ? 40 : 0)}px;
    position: relative;
    opacity: 1;
    cursor: default;
    .revFoot{
        box-shadow:  ${p => p.noHover ? `0 6px 8px -6px ${getColor(p, "@darkGrey")}` : "0 0 0 0 transparent"};
        transition: 0.2s all ease-in-out;
        background: ${p => p.noHover ? lightenColor(p, "@veryLightGrey", 97) : fadeColor(p, p.reviewed ? "@accentLightGreen" : "@accentLightBlue", 6)};
        border: 1px solid ${p => p.noHover ? getColor(p, "@darkGrey") : getColor(p, "@middleLightGrey")};
        border-top: none;
     } 
    &:hover{
        background:  ${p => p.noHover ? undefined : ((p.revisionMode ? fadeColor(p, p.reviewed ? "@accentGreen" : "@accentBlue", 6) : "transparent"))};  
        border: ${p => p.noHover ? undefined : ((p.revisionMode ? `1px solid ${getColor(p, p.reviewed ? "@accentGreen" : "@accentBlue")}` : "none"))};
        .revFoot{
            background:  ${p => p.noHover ? undefined : (p.revisionMode ? fadeColor(p, p.reviewed ? "@accentGreen" : "@accentBlue", 9) : "transparent")};  
            border: ${p => p.noHover ? undefined : (p.revisionMode ? `1px solid ${getColor(p, p.reviewed ? "@accentGreen" : "@accentBlue")}` : `1px solid transparent`)};
            border-top: none;
        } 
    }
`;
    public static RevisionFooter = styled.div`
    margin-bottom: 9px;
    height: 40px;
    position: absolute;
    bottom: -50px;
    left: -1px;
    right: -1px;
    overflow: hidden;
    button>div{margin: 0;}
`;

    public static NotAllowedInfo = styled.div`
    color: ${props => getColor(props, "@accentRed")};
    float: right;
    margin-top: 8px;
    font-size: 0.9em;
`;

    public static ActiveEditRevisionContainer = styled.div`
    width: 100%;
    min-height: 100px;
    position: relative;
    border: 1px solid ${props => getColor(props, "@middleLightGrey")};
    background: ${props => getColor(props, "@mainBackground")};
    padding: 10px;
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 40px;
    row-gap: 5px;
    button>div{margin:0;}
`;
    public static ActiveEditRevisionTitle = styled.div<{ error?: boolean }>`
    line-height: 40px;
    font-weight: bolder;
    color: ${props => props.error ? getColor(props, "@accentRed") : "inherit"};
`;
    public static RefLngButtonContent = styled.div`
    display: grid;
    grid-template-columns: max-content max-content;
    column-gap: 8px;
    align-items: center;
`;
    public static SwitchReasonGridText = styled.div<{ disabled: boolean, active: boolean }>`
    color: ${p => getColor(p, p.disabled ? "@lightGrey" : "@accentBlack")};
    font-weight: ${p => p.active ? "bolder" : "normal"};
`;
    public static SwitchReasonGrid = styled.div`
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 10px;
    align-items: center;   
    line-height: 30px;
    margin-top: 5px;
`;
    public static SwitchReasonGridIcon = styled.div<{ shown: boolean }>`
    width: ${p => p.shown ? 25 : 0}px;
    overflow: hidden; 
    transition: all 0.2s ease;
    float: left;
`;
    public static WeightSliderText = styled.div<{ color: string, textColor: string }>`
    height: 40px;
    width: 100%;
    background: ${props => getColor(props, props.color)};
    color: ${props => getColor(props, props.textColor)};
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    padding: 0 10px;
    line-height: 40px;
    float: left;
    font-weight: bolder;
`;

    public static ColumnContent = styled.div<{ info: boolean }>`
    color: ${props => props.info ? getColor(props, "@lightGrey") : getColor(props, props.theme.colors.mainForeground)};
    font-size:0.95rem;
    h1 {
        font-size: 1.2rem;
    }
    h2 {
        font-size: 1.1rem;
    }
    h3 {
        font-size: 1rem;
    }
    h4 {
        font-size: 0.95rem;
    }
    img{
        width: 100%;
        margin-left: calc((100% - 100%) / 2);
    }
    a{
        font-weight: 500;
    }
    a:hover{
        color: ${p => lightenColor(p, getColor(p, p.theme.colors.accent), 80)};
        font-weight: 600;
    }
`;
    public static ColumnContentImage = styled.div<{ imgWidth?: number, info?: boolean }>`
    color: ${props => props.info === true ? getColor(props, "@lightGrey") : "inherit"};
    margin-bottom: ${props => props.info === true ? 0 : "20px"};
    img{
        width: ${p => p.imgWidth ? p.imgWidth + "px" : "100%"};
        max-width: 100%;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
`;

    public static HotSpotContainer = styled.div<{ aspect: number, width?: number, maxWidth?: number }>`
    position: relative;
    width: ${p => p.width ? p.width + "px" : "100%"};
    padding-bottom: ${p => p.width ? `${p.width / p.aspect}px` : `${100 / p.aspect}%`};
    top: 0;
    left:0;
    z-index:0;
    margin: auto;
`;

    public static HotSpotContainerImage = styled.div`
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    z-index:1;
`;
    public static AudioContainerHeader = styled.div`
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 1rem;
        font-weight: bolder;
        color: ${p => getColor(p, "@mainForeground")};
        padding: 0 0 0 15px;
        border-bottom: 1px solid ${p => getColor(p, "@middleLightGrey")};
        margin-bottom: 10px;
        svg{
            stroke: ${p => getColor(p, "@mainForeground")};
        }
`;
    public static SectionTitleTOC = styled.div<{ open: boolean }>`
    display: block;
    font-size:1.2rem;
    font-weight: bolder;
    line-height: 40px;
    min-height:40px;
    margin-bottom:10px;
    padding-top:0px;
    width: 100%;
    transition: 0.2s all ease-out;
    border-bottom: 1px solid ${props => fadeColor(props, props.theme.colors.accentBlack, props.open ? 7 : 4)};
    color: ${props => props.open ? getColor(props, props.theme.colors.mainForeground) : getColor(props, props.theme.colors.mainForeground)};
    background: ${props => props.open ? getColor(props, props.theme.colors.veryLightGrey) : fadeColor(props, props.theme.colors.accentBlack, 2)};
    svg{
        stroke: ${props => props.open ? getColor(props, props.theme.colors.mainForeground) : getColor(props, props.theme.colors.lightGrey)};
    }
`;
    public static SectionMapContainer = styled.div`
    display: block;
    width:100%;
    transition: 0.2s all ease-in-out;
    border-right:3px solid transparent;
    &:hover{
        border-right: 3px solid ${props => getColor(props, props.theme.colors.accent)};
    }  
`;
    public static SectionMapTitleHead = styled.div`
    display: inline-block;
    line-height:1.4em;
    cursor: pointer;
    transition: 0.1s all ease-out;
    font-size:0.9rem;
    width: calc(100% - 24px);
    &:hover{
        color: ${props => getColor(props, props.theme.colors.accent)};
        font-weight:bolder;
        font-size:0.9rem;
        padding-left: 2px;
        background: ${props => getColor(props, props.theme.colors.veryLightGrey)};
    }    
`;
    public static SectionMapTitle = styled(WikiSC.SectionMapTitleHead)`
    &:hover{
        padding-left: 5px;
    }    
`;
    public static SectionMapIcon = styled.div<{ selectable: boolean }>`
    float: left;
    margin-right:5px;
    height:20px;
    transition: 0.2s all ease-out;
    cursor: ${props => props.selectable ? "pointer" : "default"};
    &:hover{
        svg{
            stroke: ${props => props.selectable ? getColor(props, props.theme.colors.accent) : undefined};
        }
    }
`;
    public static SubCategoryContainer = styled.div`
    display: block;
    padding-left:22px;
`;
    public static Breadcrumb = styled.div`
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
    public static MoreArticlesContainer = styled.div`
    line-height:32px;
    width: calc(100% + 20px);
    margin-left: -10px;
    border-left:3px solid transparent;
    transition: 0.2s ease-out;
    &:hover{
        background:${props => getColor(props, props.theme.colors.veryLightGrey)};
        border-left:3px solid ${props => getColor(props, props.theme.colors.accent)};
    }
`;
    public static Title = styled.div`
    font-size:1.5rem;
    font-weight:600;
    line-height:50px;
    margin:15px 0;
`;
    public static BreadcrumbActiveSite = styled.span`
    margin-top:2px;
`;
    public static WikiContentContainer = styled.div`
    margin: 40px 0px;
    padding: 0px;
    .searchFindingActive {
        position: relative; 
        border-bottom: 1px solid ${p => fadeColor(p, "@accent", 100)}; 
        padding: 0 0.25rem;
        background: ${p => fadeColor(p, "@accent", 5)};
        color: ${p => p.color ?? getColor(p, "accentBlack")};
        font-weight: normal;
        font-style: normal;
    }
    .searchFinding {
        position: relative; 
        border-bottom: 1px solid ${p => fadeColor(p, "@accentBlue", 100)}; 
        padding: 0 0.25rem;
        background: ${p => fadeColor(p, "@accentBlue", 5)};
        color: ${p => p.color ?? getColor(p, "accentBlack")};
        font-style: normal;
        font-weight: normal;
    }
`;
    public static SubCategoryView = styled.div`
    position: ${props => belowBreakpointOrEqual(props, "tablet") ? "unset" : "relative"};
    display: ${props => belowBreakpointOrEqual(props, "tablet") ? "block" : "inline-block"};
    width: ${props => belowBreakpointOrEqual(props, "tablet") ? "100%" : "40%"};
    z-index:101;
`;
    public static ArticleView = styled.div<{ subCategories: number }>`
    display: ${props => belowBreakpointOrEqual(props, "tablet") ? "block" : "inline-block"};
    width: ${props => belowBreakpointOrEqual(props, "tablet") ? "100%" : "calc(100% - 40%)"};
    padding: ${props => belowBreakpointOrEqual(props, "tablet") ? "0px" : "0px"};
    border: ${props => belowBreakpointOrEqual(props, "tablet") ? "none" : "1px solid " + getColor(props, props.theme.colors.lightGrey)};
    z-index:-1;
    vertical-align:top;
    min-height: calc(${props => props.subCategories} * 40px);
    background: ${props => belowBreakpointOrEqual(props, "tablet") ? getColor(props, fromTheme(props, t => t.categoryTheme.articleBackgroundColor, t => t.colors.veryLightGrey)) : getColor(props, fromTheme(props, t => t.categoryTheme.articleBackgroundColor, t => t.colors.veryLightGrey))};
`;
    public static ArticleResultContainer = styled.div`
    margin-top:-14px;
    margin-bottom: 15px;
    border-bottom: 1px solid ${props => getColor(props, props.theme.colors.lightGrey)};
    white-space: nowrap;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
`;
    public static SubCategoryItem = styled.div<{ active?: boolean }>`
    width: ${props => belowBreakpointOrEqual(props, "tablet") || !props.active ? "100%" : "calc(100% + 1px)"};
    height:40px;
    line-height:40px;
    border-left: ${props => props.active ? "3px solid " + getColor(props, fromTheme(props, t => t.categoryTheme.categoryBorderLeftColor, t => t.colors.accent)) : "none"}; 
    border-top: ${props => props.active ? "1px solid " + getColor(props, props.theme.colors.lightGrey) : "none"}; 
    border-bottom: ${props => props.active ? "1px solid " + getColor(props, props.theme.colors.lightGrey) : "none"}; 
    font-weight: ${props => props.active ? 600 : 400};
    padding:0px 15px;
    cursor: ${props => props.active ? "default" : "pointer"};
    transition: 0.2s ease-in-out;
    background: ${props => props.active ? getColor(props, fromTheme(props, t => t.categoryTheme.categoryBackgroundColorActive, t => t.colors.veryLightGrey)) : getColor(props, fromTheme(props, t => t.categoryTheme.categoryBackgroundColor, t => t.colors.mainBackground))};
    z-index:101;
    color: ${props => props.active ? getColor(props, fromTheme(props, t => t.categoryTheme.categoryFontColorActive, t => t.colors.mainForeground)) : getColor(props, fromTheme(props, t => t.categoryTheme.categoryFontColor, t => t.colors.mainForeground))};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    &:hover{
        color: ${props => props.active ? "inherit" : getColor(props, fromTheme(props, t => t.categoryTheme.categoryFontHoverColor, t => t.colors.accent))};
        font-weight: bolder;
        background: ${props => props.active ? getColor(props, fromTheme(props, t => t.categoryTheme.categoryBackgroundColorActive, t => t.colors.veryLightGrey)) : getColor(props, fromTheme(props, t => t.categoryTheme.categoryBackgroundHoverColor, t => t.colors.mainBackground))};
    }
`;
    public static SubCategoryItemMobile = styled.div<{ active?: boolean }>`
    background: ${props => props.active ? getColor(props, fromTheme(props, t => t.categoryTheme.categoryBackgroundColorActive, t => t.colors.veryLightGrey)) : "transparent"};
    border-left: 3px solid ${props => props.active ? getColor(props, fromTheme(props, t => t.categoryTheme.categoryBorderLeftColor, t => t.colors.accent)) : "transparent"};
    margin-bottom:15px;
    width: 100%;
    padding: 5px 10px;
    font-weight: ${props => props.active ? 600 : 400};
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    color: ${props => props.active ? getColor(props, fromTheme(props, t => t.categoryTheme.categoryFontColorActive, t => t.colors.mainForeground)) : getColor(props, fromTheme(props, t => t.categoryTheme.categoryFontColor, t => t.colors.mainForeground))};
    svg{
            stroke: ${props => props.active ? getColor(props, fromTheme(props, t => t.categoryTheme.categoryFontColorActive, t => t.colors.mainForeground)) : getColor(props, fromTheme(props, t => t.categoryTheme.categoryFontColor, t => t.colors.mainForeground))};
        }
`;
    public static ArticleItemMobile = styled.div<{ hide?: boolean }>`
    padding: 5px 5px 5px 20px;
    width: 100%;
    background: ${props => getColor(props, fromTheme(props, t => t.categoryTheme.articleBackgroundColor, t => t.colors.veryLightGrey))};
    border-top: 1px solid ${props => getColor(props, props.theme.colors.mainBackground)};
    color: ${props => props.hide ? props.theme.colors.lightGrey : getColor(props, fromTheme(props, t => t.categoryTheme.articleFontColor, t => t.colors.mainForeground))};
`;
    public static CatgoryArticleContainer = styled.div`
    width: 100%;
    margin-bottom: 10px;
    padding: 10px;
`;
    public static CatgoryContainerTitle = styled.div`
    width: 100%;
    line-height: 40px;
    font-size: 1rem;
    font-weight: bolder;
    color: ${p => getColor(p, p.theme.colors.mainForeground)}; 
`;
    public static ArticleLink = styled.div<{ adminInGroup: boolean }>`
    float:left;
    width: ${p => p.adminInGroup ? "calc(100% - 80px)" : "100%"};
    padding-left: 10px;
    transition: 0.2s all ease-in-out;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    line-height: 40px;
    //border-right:  ${p => p.adminInGroup ? "1px solid" + p.theme.colors.lightGrey : "none"};
`;
    public static ArticleItem = styled.div<{ hiddenArticle: boolean }>`
    transition: 0.2s all ease-in-out;
    opacity: ${p => p.hiddenArticle ? 0.7 : 1};
    width: 100%;
    background: ${props => belowBreakpointOrEqual(props, "tablet") ? getColor(props, fromTheme(props, t => t.categoryTheme.articleBackgroundColor, t => t.colors.veryLightGrey)) : getColor(props, fromTheme(props, t => t.categoryTheme.articleBackgroundColor, t => t.colors.veryLightGrey))};
    margin-bottom: ${props => belowBreakpointOrEqual(props, "tablet") ? "10px" : "0px"};
    border-bottom:1px solid ${props => getColor(props, fromTheme(props, t => t.categoryTheme.articleBorderBottomColor, t => t.colors.veryLightGrey))};
    border-right:3px solid transparent;
    transition: 0.2s all ease-in-out;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    line-height: 40px;
    color: ${props => getColor(props, fromTheme(props, t => t.categoryTheme.articleFontColor, t => t.colors.mainForeground))};
    &:hover{
        border-right:3px solid ${props => getColor(props, fromTheme(props, t => t.categoryTheme.articleBorderRightColor, t => t.colors.accent))};
        background: ${props => getColor(props, "@veryLightGrey")};
        padding-left: 5px;
        color: ${props => getColor(props, fromTheme(props, t => t.categoryTheme.articleFontHoverColor, t => t.colors.accent))};
        font-weight:bolder;
        svg{
            stroke: ${props => getColor(props, fromTheme(props, t => t.categoryTheme.articleFontHoverColor, t => t.colors.accent))};
        }
    }
`;
    public static InfoSortContainer = styled.div`
    margin-top: 40px;
    margin-bottom: -40px;
    width: 100%;
    height: 30px;
    position: relative;
`;
    public static InfoSortContainerItem = styled.div<{ wider: boolean }>`
    width: 85px;
    position: absolute;
    top: ${p => p.wider ? 40 : 0}px;
    right: 0px;
    line-height: 30px;
    border: 1px solid ${p => getColor(p, p.theme.colors.lightGrey)}; 
    background:${p => getColor(p, p.theme.colors.veryLightGrey)};
    border-bottom: none;
    color: ${p => getColor(p, p.theme.colors.mainForeground)}; 
    text-align: center;
`;
    public static SortButtonBackground = styled.div<{ trans: number, noBg: boolean }>`
    float: right;
    width: 40px;
    height: 40px;
    transition: 0.2s ease-out;
    svg{
        transition: 0.2s ease-out;
        stroke: ${p => getColor(p, p.theme.colors.mainForeground)}; 
        transform-origin: center center;
    }
    &:hover{
        background: ${p => p.noBg ? "transparent" : getColor(p, p.theme.colors.accent)};         
        svg{
            stroke: ${p => getColor(p, p.theme.colors.mainBackground)}; 
            transform: scale(1.3);
    }
    }
`;
    public static SidebarContainerTitleChapter = styled.div<{ moreSpace?: boolean }>`
    width:100%;
    height: 20px;
    font-weight: bolder;
    margin-top: ${p => p.moreSpace ? 10 : 0}px;
    position: relative;
`;
    public static SidebarContainerTitleClickArea = styled.div`
    width: 100%;
    height: 20px;
    cursor: pointer;
    position: absolute;
    top:0;
    left:0;
    &:hover{
        color: ${props => getColor(props, props.theme.colors.accent)};
    }
`;
    public static SidebarContainerAlternativeTitle = styled.div`
        width: calc(100% - 40px);
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;  
`;
    public static SidebarContainerTitleClickAreaChevron = styled.div`
    float: right;
    transition: all 0.2s ease-out;
    cursor: pointer;
    &:hover{
        svg{
            stroke: ${props => getColor(props, props.theme.colors.accent)};
            stroke-width: 2.5px;
    }
    }
`;
    public static ResultContainer = styled.div<{ found: boolean }>`
    display: grid;
    display: -ms-grid;
    grid-template-columns: ${p => p.found ? "1fr 40px 40px" : "1fr 0 0"};
    -ms-grid-columns: ${p => p.found ? "1fr 40px 40px" : "1fr 0 0"};
    position: relative;
`;
    public static Results = styled.div`
    float: right;
    color: ${props => belowBreakpointOrEqual(props, "mobile") ? getColor(props, props.theme.color) : getColor(props, props.theme.colors.lightGrey)};
    width: 80px;
    //background: ${props => belowBreakpointOrEqual(props, "mobile") ? "#101010" : getColor(props, props.theme.colors.veryLightGrey)};
    text-align: center;
    height: 24px;
    line-height: 24px;
    margin-top: -14px;
    font-size: 0.9em;
    //padding-right: 13px;
`;

    public static SidebarContainerContentSimilarArticles = styled(SidebarContainerContent)`
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;
    public static PLaylistName = styled.div`
    font-weight: bolder;
    margin: 0;
    padding: 0;
    //border-bottom: 1px solid ${props => getColor(props, props.theme.colors.lightGrey)};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
    font-size: 0.9em;
    a{
        color: ${props => getColor(props, props.theme.colors.mainForeground)};
        &:hover{
            color: ${props => getColor(props, props.theme.colors.accent)};
        }
    }
`;
    public static PlaylistNameImage = styled.div`
    float: left;
    margin-right: 5px;
    margin-top: 2px;
`;
    public static CloseX = styled.div<{ hasResults: boolean }>`
    position: absolute;
    top: 7px;
    right: ${p => p.hasResults ? 90 : 10}px;
    cursor: pointer;
    transition: all 0.2s ease-out;
    svg{
        stroke: ${props => getColor(props, props.theme.colors.lightGrey)};
    }
    &:hover{
        svg{
            stroke: ${props => getColor(props, props.theme.colors.accent)};
        }
    }
`;
    public static LinksContainer = styled.div<{ length: number }>`
    width: 100%;
    height: calc(21px * ${p => p.length});
    padding-left: 15;
`;
    public static LinkToContainer = styled.div`
    width: calc(100% - 20px);
    float: left;
`;

    public static OfflineInfo = styled.div`
    width: 100%;
    background: ${props => fadeColor(props, getColor(props, props.theme.colors.darkGrey), 10)};
    color:${props => getColor(props, props.theme.colors.accent)};
    line-height: 40px;
    margin-top: 10px;
    margin-bottom: -10px;
    padding-left: 11px;
    text-transform: uppercase;
    font-weight: bolder;
    font-size: 0.85rem;
    svg{
        stroke: ${props => getColor(props, props.theme.colors.accent)};
    }
`;
    public static ReferenceContent = styled.div`
    padding: 0px 5px 5px 5px;
    background:${p => fadeColor(p, getColor(p, p.theme.colors.accentBlue), 10)};
    border: 1px solid ${props => getColor(props, props.theme.colors.middleLightGrey)};
`;
    public static InnerContainer = styled.div`
    display: grid;
    grid-template-columns: 200px auto;
    grid-template-rows: min-content;
    margin-bottom: 10px;
  `;
    public static InnerContainerDate = styled.div`
  display: grid;
  grid-template-columns: 200px auto;
  grid-template-rows: min-content;
  margin-bottom: -10px;
`;
    public static ICTitle = styled.div`
    font-weight: bolder;
    line-height: 40px;
    padding-left: 15px;
`;
    public static ICTitle2 = styled.div`
    line-height: 40px;
    padding-left: 0px;
`;
    public static ICInput = styled.div`
`;



    public static ICInputDate = styled.div`
    //margin-left: -3px;
`;


    public static EditInfo = styled.div`
    color: ${props => getColor(props, props.theme.colors.mainBackground)};
    float: right;
    padding-left:15px;
    padding-right:15px;
    font-weight:bolder;
    font-size:1rem;
    text-transform: uppercase;
    margin-top: -3px;
`;
    public static BasicSettingsContainer = styled.div<{ minimized: boolean }>`
    background: ${props => props.minimized ? getColor(props, props.theme.colors.mainBackground) : getColor(props, props.theme.colors.veryLightGrey)};
    border: 1px solid ${props => props.minimized ? "transparent" : getColor(props, props.theme.colors.veryLightGrey)};
    margin-top: ${props => props.minimized ? "30px" : "30px"};
    margin-bottom: ${props => props.minimized ? 0 : "15px"};
    padding:8px;
    min-height:32px;
    transition: 0.1s all ease-out;
    cursor: ${props => props.minimized ? "pointer" : "0"};
    button>div{margin: 0;}
    &:hover{
        svg{
            stroke: ${props => props.minimized ? getColor(props, props.theme.colors.accent) : undefined};
        }
    }
`;
    public static SectionMenuContainer = styled.div`
    margin-top:10px;
    height:40px;
    background: ${props => getColor(props, props.theme.colors.veryLightGrey)};
    border-left: 3px solid ${props => getColor(props, props.theme.colors.accent)};
`;
    public static DropdownTreeSelectContainer = styled.div`
    * {
        outline: none;
    }
    .react-dropdown-tree-select .dropdown .dropdown-trigger{
        padding:0;
        line-height: unset;
    }
    .search {
        color: ${p => getColor(p, p.theme.colors.mainForeground)};
        border:1px solid grey;
    }
    .no-matches{
        color: ${p => getColor(p, p.theme.colors.accentRed)};
        font-weight: bolder;
        line-height: 60px;
        padding-left:10px;
    }
    .tag-item .search{
        padding: 5px;
        line-height: 20px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 30 30' stroke='%23b9b9b9' fill='none' stroke-width='1.5' stroke-linejoin='round' stroke-linecap='round'%3E%3Cg transform='translate(-1.5 -1.5)'%3E%3Cpath d='M24.8,16.1c0,4.8-3.9,8.7-8.7,8.7s-8.7-3.9-8.7-8.7c0-4.8,3.9-8.7,8.7-8.7c0,0,0,0,0,0 C20.9,7.4,24.8,11.3,24.8,16.1z'/%3E%3Cpath d='M26.9,26.9l-4.7-4.7' /%3E%3C/g%3E%3C/svg%3E");
        background-size: 20px;
        background-position-x: 2px;
        background-position-y: center;
        background-repeat: no-repeat;
        padding-left: 28px;
        background-color: transparent;
        border-color: ${p => getColor(p, p.theme.colors.veryLightGrey)};
        border-bottom-color: ${p => getColor(p, p.theme.colors.veryLightGrey)};
        transition: 0.2s all ease-out;
        width: calc(100% - 30px);
        &:focus{
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 30 30' stroke='%23313638' fill='none' stroke-width='1.5' stroke-linejoin='round' stroke-linecap='round'%3E%3Cg transform='translate(-1.5 -1.5)'%3E%3Cpath d='M24.8,16.1c0,4.8-3.9,8.7-8.7,8.7s-8.7-3.9-8.7-8.7c0-4.8,3.9-8.7,8.7-8.7c0,0,0,0,0,0 C20.9,7.4,24.8,11.3,24.8,16.1z'/%3E%3Cpath d='M26.9,26.9l-4.7-4.7' /%3E%3C/g%3E%3C/svg%3E");
            background-color: ${p => getColor(p, p.theme.colors.mainBackground)}; 
            color: ${p => getColor(p, p.theme.colors.mainForeground)};
            border-bottom-color: ${p => getColor(p, p.theme.colors.darkGrey)};
        }
    }
    .react-dropdown-tree-select .dropdown .dropdown-content {
        width: 100%;
        min-width:300px;
        max-height:50vh;
        overflow: auto;
    }

    .toggle.collapsed:after {
        content: "";
        transform: rotate(180deg);
        float: left;
        width: 20px;
        height: 20px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 30 30' stroke='%23313638' fill='none' stroke-width='1.5' stroke-linejoin='round' stroke-linecap='round'%3E%3Cpath d='M21.5,18.3L15,11.8l-6.5,6.5' /%3E%3C/svg%3E");
        background-size: contain;
        background-position-x: center;
        background-position-y: 0px;
        background-repeat: no-repeat;
        margin-left: 5px;
}
    .toggle.expanded:after{
        content: "";
        float: left;
        width: 20px;
        height: 20px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 30 30' stroke='%23950013' fill='none' stroke-width='1.5' stroke-linejoin='round' stroke-linecap='round'%3E%3Cpath d='M21.5,18.3L15,11.8l-6.5,6.5' /%3E%3C/svg%3E");
        background-size: contain;
        background-position-x: center;
        background-position-y: 0px;
        background-repeat: no-repeat;
        margin-left: 5px;
    }
    .react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.bottom:after{
        content: "";
        transform: rotate(180deg);
        width: 30px;
        height: 30px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 30 30' stroke='%23313638' fill='none' stroke-width='2' stroke-linejoin='round' stroke-linecap='round'%3E%3Cpath d='M21.5,18.3L15,11.8l-6.5,6.5' /%3E%3C/svg%3E");
        background-size: contain;
        background-position-x: center;
        background-position-y: -5px;
        background-repeat: no-repeat;
        top:0;
        right: 0;
        margin-left: 10px;
        position: absolute;
    }
    .react-dropdown-tree-select .dropdown .dropdown-trigger.arrow.top:after {
        content: "";
        width: 30px;
        height: 30px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 30 30' stroke='%23950013' fill='none' stroke-width='2' stroke-linejoin='round' stroke-linecap='round'%3E%3Cpath d='M21.5,18.3L15,11.8l-6.5,6.5' /%3E%3C/svg%3E");
        background-size: contain;
        background-position-x: center;
        background-position-y: 5px;
        background-repeat: no-repeat;
        top:0;
        right: 0;
        margin-left: 10px;
        position: absolute;
    }
    .tag {
        color: #000;
        padding:5px;
        border-radius: 0px;
        background-color: ${p => fadeColor(p, getColor(p, p.theme.colors.darkGrey), 5)};
    }
    .tag-remove {
        color: transparent;
        font-size: 100%;
        line-height: 100%;
        cursor: pointer;
        background-color: transparent;
        border: none;
        font-weight: bolder;
        padding-left: 10px;
        outline: none;
        transition: 0.2s all ease-out;
        margin-left:5px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 30 30' stroke='%23b9b9b9' fill='none' stroke-width='2' stroke-linejoin='round' stroke-linecap='round'%3E%3Cg transform='translate(-110.966 -35.966)'%3E%3Cline x1='119.2' y1='44.2' x2='132.7' y2='57.7' /%3E%3Cline x1='132.7' y1='44.2' x2='119.2' y2='57.7' /%3E%3C/g%3E%3C/svg%3E");
        background-size: contain;
        background-position-x: center;
        background-position-y: center;
        background-repeat: no-repeat;

        &:hover{
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 30 30' stroke='%23950013' fill='none' stroke-width='3' stroke-linejoin='round' stroke-linecap='round'%3E%3Cg transform='translate(-110.966 -35.966)'%3E%3Cline x1='119.2' y1='44.2' x2='132.7' y2='57.7' /%3E%3Cline x1='132.7' y1='44.2' x2='119.2' y2='57.7' /%3E%3C/g%3E%3C/svg%3E");
        }
    }
    .checkbox-item {
        position: relative;
        width: 12px;
        height: 12px;
        margin-right: 5px;
        cursor: pointer;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        outline: 0;
        vertical-align: middle;
  }
  .checkbox-item:before {
    content: "";
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        border: 1.5px solid ${p => getColor(p, p.theme.colors.lightGrey)};
        border-radius:  2px;
  }
  .checkbox-item:checked:before {
        top: 0px;
        left: 0px;
        height: 50%;
        transform: rotate(-45deg) scale(1.2);
        border-top-style: none;
        border-right-style: none;
        border-width: 2px;
        border-bottom-left-radius: 1px;
        border-color: ${p => getColor(p, p.theme.colors.accentGreen)};
  }
`;
    public static ButtonDivider = styled.div`
    width:1px;
    margin: 6px 10px;
    height: 28px;
    background:${props => getColor(props, props.theme.colors.lightGrey)};
    float:left;
`;
    public static Table = styled.table`
    width: 100%;
    border: 1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
`;
    public static Th = styled.th`
    text-align: left;
    font-weight: bolder;
    border-bottom: 1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
    padding: 10px;
    font-size: 0.9rem;
    height: 40px;
    background: ${p => lightenColor(p, getColor(p, p.theme.colors.veryLightGrey), 96)};
    transition: all 0.2s ease;
`;
    public static Td = styled.td<{ clickable?: boolean }>`
    text-align: left;
    border-bottom: 1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
    padding: 0 10px;
    font-size: 0.9rem;
    cursor: ${p => p.clickable ? "pointer" : "default"};
    transition: all 0.2s ease;
    &:hover{
        background: ${p => p.clickable ? "rgba(0,0,0,0.1)" : "transparent"};
    }
`;
    public static TdLegend = styled.tr<{ show: boolean }>`
    height: ${p => p.show ? "120px" : "40px"};
    transition: height 0.2s ease;
`;
    public static Tr = styled.tr<{ even: boolean }>`
    background: ${p => p.even ? lightenColor(p, getColor(p, p.theme.colors.veryLightGrey), 102) : fadeColor(p, getColor(p, p.theme.colors.veryLightGrey), 100)};
    transition: all 0.2s ease;
    color: ${p => getColor(p, p.theme.colors.mainForeground)};
    &:hover{
        background: ${p => fadeColor(p, getColor(p, p.theme.colors.accentBlue), 10)};
        color: ${p => getColor(p, p.theme.colors.accentBlack)};
    }
`;
    public static DropdownTreeSelectContainerStyled = styled(WikiSC.DropdownTreeSelectContainer)`
    float: left;
    margin-right: 5px;
    .tag-item .search{
        border-color: transparent;
        border-bottom-color: transparent;
        width: 100%;
        &:focus{
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 30 30' stroke='%23313638' fill='none' stroke-width='1.5' stroke-linejoin='round' stroke-linecap='round'%3E%3Cg transform='translate(-1.5 -1.5)'%3E%3Cpath d='M24.8,16.1c0,4.8-3.9,8.7-8.7,8.7s-8.7-3.9-8.7-8.7c0-4.8,3.9-8.7,8.7-8.7c0,0,0,0,0,0 C20.9,7.4,24.8,11.3,24.8,16.1z'/%3E%3Cpath d='M26.9,26.9l-4.7-4.7' /%3E%3C/g%3E%3C/svg%3E");
            color: ${p => getColor(p, p.theme.colors.mainForeground)};
            border-bottom-color: transparent;
            border-color: transparent;
            background-color: transparent;
        }
    }
`;
    public static Container = styled.div`
    text-align: left;
`;
    public static ButtonContainer = styled.div`
    height: 42px;
    padding: 0;
    float: left;
    border: 1px solid #b9b9b9;
    margin-right: 5px;
    margin-bottom:2px;
`;

    public static FilterContainer = styled.div`
   display: block;
   height: 42px;
   width: 100%;
`;
    public static TableContainer = styled.div`
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
`;
    public static Legend = styled.div`
`;
    public static WikiSelectBox = styled.div`
        width: 115px; 
        position: absolute;
        right:40px;
        bottom:0px;
        z-index:10;
`;
    public static WikiMoreOptionsBox = styled.div`
        position: absolute;
        right:0px;
        top:0px;
`;

    public static ColumnContainer = styled.div<{ activated: boolean, revisionMode: boolean }>`
    display: grid;
    grid-template-columns: ${p => p.revisionMode ? "1fr" : "1fr 40px"};
    width: 100%;
    min-height: 240px;
    margin: 0;
    border-left: ${p => p.revisionMode ? 0 : 3}px solid ${props => props.activated ? getColor(props, props.theme.colors.mainBackground) : lightenColor(props, getColor(props, props.theme.colors.mainBackground), 95)};
    background: ${props => props.revisionMode ? getColor(props, props.theme.colors.mainBackground) : (props.activated ? getColor(props, props.theme.colors.mainBackground) : lightenColor(props, getColor(props, props.theme.colors.mainBackground), 95))};
    transition: 0.1s all;
    box-shadow: ${props => props.activated ? "0 6px 8px -6px black" : "none"};
    button>div{margin: 0;}
    &:hover{
        border-left: ${p => p.revisionMode ? 0 : 3}px solid ${props => getColor(props, props.theme.colors.accent)};
    }
`;

    public static SCHeaderContainer = styled.div<{ activated: boolean }>`
  background: ${props => lightenColor(props, getColor(props, props.theme.colors.veryLightGrey), 94)};
  padding:0;
  text-align: center;
  transition: 0.1s all ease-in-out;
  position: relative;
  &:hover{
      background: ${props => lightenColor(props, getColor(props, props.theme.colors.veryLightGrey), 90)};
  }
`;

    public static ButtonMore = styled(Button)`
    display: block;
    transition: 0.2s all ease-out;
`;

    public static WECReferenceContent = styled.div<{ revisionMode: boolean }>`
    display: block;
    transition: 0.2s all ease-out;
    font-size: 0.8rem;
    padding: ${p => p.revisionMode ? "0px" : "10px"};
    color: ${p => p.revisionMode ? getColor(p, "@darkGrey") : lightenColor(p, getColor(p, p.theme.colors.mainForeground), 100)};
    background:${p => p.revisionMode ? fadeColor(p, "@accentLightBlue", 5) : fadeColor(p, getColor(p, p.theme.colors.accentBlue), 3)};
    margin-bottom: 10px;
    border: ${p => p.revisionMode ? `1px solid ${fadeColor(p, "@accentLightBlue", 20)}` : "none"};
    box-shadow: ${p => p.revisionMode ? "0 6px 8px -6px #000" : "none"};
    .revisionModeContent{
        padding: ${p => p.revisionMode ? "5px 10px" : "0px"};
    }

    h3{
        background: ${p => p.revisionMode ? fadeColor(p, "@accentLightBlue", 5) : fadeColor(p, getColor(p, p.theme.colors.accentBlue), 10)};
        border-bottom: 1px solid ${p => p.revisionMode ? fadeColor(p, "@accentLightBlue", 20) : getColor(p, p.theme.colors.middleLightGrey)};
        font-size: 0.9rem;
        font-weight: bolder;
        margin:0;
        width: 100%;
        padding: ${p => p.revisionMode ? 10 : 5}px;
        margin-bottom:5px;
        color: ${p => p.revisionMode ? getColor(p, "@accentBlue") : lightenColor(p, getColor(p, p.theme.colors.mainForeground), 100)};
    }
`;

    public static TableSelectorInfo = styled.div`
    float: left;
    line-height: 30px;
    color: ${props => getColor(props, props.theme.colors.accent)};
    svg{
        stroke: ${props => getColor(props, props.theme.colors.accent)};
    }
`;
    public static TableSelectorBox = styled.div`
    float: right;
`;
    public static CloseButton = styled.div`
    position: absolute;
    top: 0;
    right: 4px;
    z-index: 5;
    button>div{margin: 0;}
`;
    public static InactiveEditorContainer = styled.div`
    padding: 10px;
    opacity: 0.7;
    background: ${p => getColor(p, "@veryLightGrey")};
    user-select: none;
    transition: all 0.2s ease-out;
    border: 1px solid ${props => fadeColor(props, "@middleLightGrey", 0)};
    &:hover{
        opacity: 1;
        background: ${p => getColor(p, "@mainBackground")};
        border: 1px solid ${props => getColor(props, "@middleLightGrey")};
    }
`;
    public static EditorContainer = styled.div<{ revisionMode: boolean }>`
    padding: 0px ${p => p.revisionMode ? 0 : 4}px;
    margin-top: ${p => p.revisionMode ? -9 : 0}px;
    ${p => p.revisionMode && "p{margin-bottom: 0.5rem;line-height: 1.2em;} ul{margin-bottom: 0.5rem;}"}
    
    .ql-snow .ql-tooltip.ql-flip{
        height: 70px;
        background-image: url('${p => globalSettings.editorToolTipImage}');
        background-repeat: no-repeat;
        background-position: bottom center;
        background-size: 100%;
        z-index: 2147483637;
    }
    .ql-snow .ql-tooltip[data-mode=link]::before {
        content: "Link:";
    }
    .ql-snow .ql-tooltip.ql-editing input[type=text] {
        outline: none;
    }
    .ql-tooltip.ql-editing.ql-flip{
        left: 50% !important;
        top: 30% !important;
        transform: translate(-50%, -50%) !important;
    }
`;
    public static SectionsArea = styled.div`
    font-size: 0.9rem;
    font-weight: bolder;
    margin-left:0px;
    margin-top:-8px;
    margin-left:-8px;
    padding: 0 8px;
    width: calc(100% + 16px);
    height:56px;
    line-height:48px;
    margin-bottom:10px;
    background:${props => lightenColor(props, getColor(props, props.theme.colors.veryLightGrey), 100)};
    color: ${props => getColor(props, props.theme.colors.mainForeground)};
    border-bottom:2px solid ${props => getColor(props, props.theme.colors.accent)};
    input{
        font-weight: 700;
        font-family: ${props => props.theme.fontFamily};
        font-size:0.85rem;
    }
`;
    public static ButtonRow = styled.div`
    width:100%;
    background:${props => getColor(props, props.theme.colors.veryLightGrey)};
    padding-bottom:10px;
    height:50px;
`;
    public static SectionHeaderButton = styled(Button)`
    margin-top:4px;
`;
    public static SectionContainerOuter = styled.div<{ active: boolean, minimized: boolean }>`
    background: ${props => props.active || props.minimized ? getColor(props, props.theme.colors.mainBackground) : getColor(props, props.theme.colors.veryLightGrey)};
    border: 1px solid ${props => props.active ? getColor(props, props.theme.colors.darkGrey) : props.minimized ? "transparent" : getColor(props, props.theme.colors.veryLightGrey)};
    box-shadow: ${props => props.active ? "0 6px 8px -2px darkgrey" : "0 0 0 0 darkgrey"};
    margin-top: ${props => props.minimized ? 0 : "10px"};
    margin-bottom: ${props => props.minimized ? 0 : "15px"};
    padding:8px;
    min-height:32px;
    transition: 0.1s all ease-out;
    cursor: ${props => props.minimized ? "pointer" : "0"};
    &:hover{
        svg{
            stroke: ${props => props.minimized ? getColor(props, props.theme.colors.accent) : undefined};
        }
    }
`;
    public static TypeSelectOuter = styled.div`
    opacity: 0.5;
    position: relative;
    width: 100px;
    height:32px;
    float:left;
    border:1px solid ${props => getColor(props, props.theme.colors.lightGrey)};
    &:hover{
        border:1px solid ${props => getColor(props, props.theme.colors.darkGrey)};
    }
`;
    public static TypeSelect = styled.div`
    position: absolute;
    width: 100%;
    top: 0;
    left:0;
    font-size: 0.7rem;
    line-height: 32px;
    padding-left:10px;
    transition: 0.2s all ease-out;
`;
    public static TypeOptionContainer = styled.div`
    position: absolute;
    top: 32px;
    left: -1px;
    width: calc(100% + 2px);
    box-shadow: 0 6px 8px -2px ${props => getColor(props, props.theme.colors.mainForeground)};
    background:${props => getColor(props, props.theme.colors.mainBackground)};
    transition: 0.2s all ease-out;
`;
    public static TypeOption = styled.div<{ selected: boolean }>`
    display: block;
    width: 100%;
    height:24px;
    line-height:24px;
    font-size: 0.7rem;
    padding: 0 10px;
    transition: 0.2s all ease-out;
    background: ${props => props.selected ? getColor(props, props.theme.colors.darkGrey) : getColor(props, props.theme.colors.mainBackground)};
    font-weight: ${props => props.selected ? "bolder" : "normal"};
    color: ${props => props.selected ? getColor(props, props.theme.colors.veryLightGrey) : getColor(props, props.theme.colors.mainForeground)};
    border-left: 5px solid ${props => props.selected ? getColor(props, props.theme.colors.accent) : getColor(props, props.theme.colors.veryLightGrey)};
    cursor: ${props => props.selected ? "default" : "pointer"};
    &:hover{
        background: ${props => getColor(props, props.theme.colors.darkGrey)};
        color: ${props => getColor(props, props.theme.colors.veryLightGrey)};
        font-weight:bolder;
        border-left: 5px solid ${props => lightenColor(props, getColor(props, props.theme.colors.accent), 100)};
    }
`;
    public static ButtonDividerRight = styled.div`
    width:1px;
    margin: 6px 0;
    height: 20px;
    background:${props => getColor(props, props.theme.colors.lightGrey)};
    float:right;
`;
    public static WFOuterContainer = styled.div`
    width: 100%;
    padding: 0;
    margin-top: 20px;
`;
    public static WFHeader = styled.div`
    width: 100%;
    font-size: 1.2rem;
    font-weight: bolder;
    border-bottom: 1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
    line-height: 40px;
    margin-bottom: 15px;
    button>div{margin: 0;}
`;
    public static WFElements = styled.div`
    width: 100%;
    background: ${p => getColor(p, p.theme.colors.mainBackground)};
`;
    public static WFQuestion = styled.div`
    font-weight: bolder;
    color: ${p => getColor(p, p.theme.colors.mainForeground)};
    min-height: 40px;
    width: 100%;
    background: ${p => getColor(p, p.theme.colors.veryLightGrey)};
    padding: 12px 10px;
    border-left: 3px solid ${p => getColor(p, p.theme.colors.accent)};
    font-size: 1rem;
`;
    public static WFAnswer = styled.div<{ isMobile: boolean }>`
    color: ${p => getColor(p, p.theme.colors.mainForeground)};
    width: 100%;
    padding: 10px;
    margin-bottom: ${p => p.isMobile ? "0px" : "10px"};
    border: 1px solid ${p => getColor(p, p.theme.colors.veryLightGrey)};
    border-top: none;
    box-shadow: 0 6px 8px -6px ${p => getColor(p, p.theme.colors.mainForeground)};
    min-height: 60px;
`;
    public static WFContactInfo = styled.div`
    width: 100%;
    padding: 10px;
`;
    public static WFImage = styled.div`
    width: 100%;
    margin-top:10px;
    img{
        max-width:100%; 
        height:auto;
    }
`;
    public static FooterContainer = styled.div`
    margin: 20px 0;
    display : -ms-flexbox;
    display:flex; 
    -ms-flex-wrap : wrap;
    flex-wrap : wrap;
    -ms-flex-pack : justify;
    justify-content : space-between;
    -ms-flex-wrap : wrap;
    flex-flow: wrap;
    -ms-flex-align : center;
	align-items:center;
`;
    public static FooterIconContainer = styled.div<{ active: boolean }>`
    margin :2px;
    background:${props => props.active ? lightenColor(props, getColor(props, props.theme.colors.veryLightGrey), 90) : getColor(props, props.theme.colors.veryLightGrey)};
    padding:2px;
    border-bottom:${props => props.active ? "1px solid " + getColor(props, props.theme.colors.accent) : "1px solid transparent"};
    transition: 0.2s ease-in-out;
    cursor:${props => props.active ? "default" : "pointer"};
    &:hover{
        background: ${props => lightenColor(props, getColor(props, props.theme.colors.veryLightGrey), 90)};
        border-bottom:1px solid ${props => getColor(props, props.theme.colors.accent)};
    }
`;
    public static FooterIcon = styled.div`
    width:40px;
    height:40px;
`;
    public static CategoryHeaderContainer = styled.div`
    width: ${p => p.theme.content.width}px;
    top: ${p => appendPx(p.theme.headerHeight)};
    background: ${props => getColor(props, props.theme.colors.mainBackground)};
    position:fixed;
    height:fit-content;
    z-index: 10;
    padding: 5px 0;
`;
    public static CategoryHeaderContainerHome = styled.div<{ bgImageUrl: string }>`
    /* width: calc(110% + 20px);
    margin-left: calc(-5% - 10px); */
    width: 111.12%;
    margin-left: -5.56%;
    position:relative;
    height: ${props => appendPx(fromTheme(props, t => t.searchContainerHeight, t => 127))};
    background:${props => lightenColor(props, getColor(props, props.theme.colors.veryLightGrey), 100)};
    background-image: url(${p => p.bgImageUrl});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    border-bottom: 1px solid ${props => lightenColor(props, getColor(props, props.theme.colors.veryLightGrey), 95)};
    margin-bottom:10px;
    margin-top: -2px;
`;
    public static CategoryHeaderNewsContainer = styled.div`
    width:100%;
    position:absolute;
    top:0;
    left:0;
`;
    public static CategorySearchContainerHome = styled.div`
    position:absolute;
    opacity:0.98;
    top:${props => belowBreakpointOrEqual(props, "tablet") ? "57px" : "calc(" + appendPx(fromTheme(props, t => t.searchContainerHeight, t => 127)) + " / 2)"};
    left:${props => belowBreakpointOrEqual(props, "tablet") ? "0px" : "30%"};
    width:${props => belowBreakpointOrEqual(props, "tablet") ? "100%" : "40%"};
    z-index: 2147483630;
`;
    public static NAInnerContainer = styled.div`
    display: grid;
    grid-template-columns: 130px auto;
    grid-template-rows: min-content;
    margin-bottom: 10px;
  `;
    public static NAICTitle = styled.div<{ noBorder?: boolean, filledOut?: boolean }>`
    font-weight: bolder;
    line-height:40px;
    border-left: 3px solid ${props => props.noBorder ? "transparent" : props.filledOut ? getColor(props, props.theme.colors.accentGreen) : getColor(props, props.theme.colors.accentRed)};
    padding-left:15px;
`;
    public static NAICInput = styled.div`
`;
    public static NAImageContainer = styled.div<{ imageUrl?: string }>`
    height: auto;
    width: 152px;
    float: right;
    background-image: url('${props => props.imageUrl ?? "https://picsum.photos/800/200"}');
    background-size: cover;
    background-position: center center;
    text-align: right;
    padding: 5px;
    cursor: pointer;
    transition: 0.1s all ease-in;
    svg{
        transition: 0.1s all ease-in;
        stroke: ${props => fadeColor(props, getColor(props, props.theme.colors.mainBackground), 50)};
    }
    &:hover{
        box-shadow: 0 6px 8px -6px ${props => getColor(props, props.theme.colors.mainForeground)};
        backdrop-filter:  opacity(0.2);
        svg{
            stroke: ${props => fadeColor(props, getColor(props, props.theme.colors.mainBackground), 100)};
    }
    }
`;
    public static NAInputButton = styled.input`
    display: none;
`;
    public static NAInputCustomButton = styled.label`
    border: 1px solid ${props => getColor(props, props.theme.colors.lightGrey)};
    display: inline-block;
    padding: 0px 12px;
    line-height: 38px;
    font-family: ${props => props.theme.fontFamily};
    font-size:14px;
    background: ${props => getColor(props, props.theme.colors.mainBackground)};
    cursor: pointer;
    color: ${props => getColor(props, props.theme.colors.mainForeground)};
    height:38px;
    transition: 0.1s all ease-in;
    svg{
        stroke: ${props => getColor(props, props.theme.colors.mainForeground)};
    }
    &:hover{
        border: 1px solid ${props => getColor(props, props.theme.colors.darkGrey)};
        background: ${props => getColor(props, props.theme.colors.veryLightGrey)};
    }
`;
    public static NAIconStatus = styled.div`
    display:inline-block;
    line-height:40px;
    color: ${props => getColor(props, props.theme.colors.lightGrey)};
    margin-left:10px;
`;
    public static VideoContainerOuter = styled.div<{ width: string, isMobile: boolean }>`
    position: fixed;
    bottom: 0;
    width: ${p => p.width};
    left: ${p => p.isMobile ? 0 : "50%"};
    ${p => !p.isMobile && "transform: translateX(-50%);"}
    top: 60px;
    background: ${p => fadeColor(p, getColor(p, p.theme.colors.accentBlack), 2)};
    z-index: 2147483630;
    backdrop-filter: blur(20px);
    overflow: hidden;
    background-image:
        linear-gradient(to right, rgba(0,0,0,0.95) 21px, transparent 21px),
        linear-gradient(to bottom, rgba(0,0,0,0.95) 21px, transparent 21px),
        linear-gradient(to right, rgba(0,0,0,0.95) 21px, transparent 21px),
        linear-gradient(to bottom, rgba(0,0,0,0.95) 21px, transparent 21px),
        linear-gradient(to bottom, transparent 21px, rgba(0,0,0,0.95) 21px);
    background-size: calc(21px * 2) 21px, calc(21px * 2) 21px, calc(21px * 2) 21px, calc(21px * 2) 21px, 100% calc(100% - 21px * 3);
    background-repeat: repeat-x;
    background-position: 0 21px, top left, 0 calc(100% - 21px), bottom left, 0 21px;
    padding: ${p => belowBreakpointOrEqual(p, "tablet") ? "0" : "calc(21px * 3) calc(21px * 2.5);"};
    box-sizing: border-box;
`;

    public static VideoContainerInner = styled.div`
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${p => belowBreakpointOrEqual(p, "tablet") ? "100%" : "calc((100vh - 210px) * (16 / 9))"};
    max-width: 100%;
    z-index: 2;
    text-align: center;
`;

    public static ShowInfo = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    width: 320px;
    background: rgba(0,0,0,0.8);
    backdrop-filter: blur(3px);
    z-index: 3;
    border: 1px solid ${p => getColor(p, p.theme.colors.accent)};
    color: ${p => getColor(p, p.theme.colors.mainBackground)};
    padding: 20px;
    text-align: center;
    font-size: 1.85rem;
    box-shadow: 0 0 10px 10px ${p => getColor(p, p.theme.colors.accentBlack)};
	animation: ${flyIn} 0.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) both;
    svg{
        stroke: ${p => getColor(p, p.theme.colors.accent)};
    }
`;
    public static VideoCancel = styled.div`
    position: absolute;
    left: 17px;
    bottom: -20px;
    font-size: 0.75rem;
    color: ${p => getColor(p, p.theme.colors.mainBackground)};
    cursor: pointer;
    &:hover{
        color: ${p => getColor(p, p.theme.colors.accent)};
    }
 `;
    public static VideoNotAgain = styled(WikiSC.VideoCancel)`
    right: 17px;
    left: unset;
`;
    public static QuizContainerTab = styled.div`
    height:40px;
    line-height:40px;
    padding: 0 15px;
    border: 1px solid ${p => getColor(p, p.theme.colors.lightGrey)};
    border-bottom: 1px solid ${p => getColor(p, p.theme.colors.veryLightGrey)};
    background: ${p => getColor(p, p.theme.colors.veryLightGrey)};
    font-weight: bolder;
    width: fit-content;
    position: absolute;
    left: -1px;
    top: -40px;
`;
    public static QuizContainerOuter = styled.div`
    border: 1px solid ${p => getColor(p, p.theme.colors.lightGrey)};
    width: 100%;
    background: ${p => getColor(p, p.theme.colors.veryLightGrey)};
    position: relative;
    margin-top: 60px;
`;
    public static QuizContainerInfo = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 150px 1fr 95px;
    grid-template-rows: 1fr;
`;

    public static QuizContainerRating = styled.div`
    display: block;
    grid-row:3;
`;



    public static WikiQuiz = styled.div<{ homeView: boolean }>`
    //margin-top: ${p => p.homeView ? belowBreakpointOrEqual(p, "tablet") ? "20px" : "50px" : "unset"};
    padding: 1px;
    display: grid;
    grid-template-columns: ${p => (belowBreakpointOrEqual(p, "tablet") || p.homeView) ? "1fr" : belowBreakpointOrEqual(p, "desktop") ? "2fr 1fr" : "3fr 1fr"};
    grid-template-rows: ${p => belowBreakpointOrEqual(p, "tablet") ? p.homeView ? "1fr" : "1fr 1fr" : "1fr"};
`;
    public static WikiQuizMaster = styled.div`
    width: 100%;
    height: ${p => belowBreakpointOrEqual(p, "tablet") ? "unset" : belowBreakpointOrEqual(p, "desktop") ? "240px" : "250px"};
    aspect-ratio: ${p => belowBreakpointOrEqual(p, "tablet") ? "unset" : "unset"};
    background: linear-gradient(to bottom, ${p => fadeColor(p, getColor(p, p.theme.colors.mainBackground), 50)} 0%, ${p => fadeColor(p, getColor(p, p.theme.colors.middleLightGrey), 80)} 50%, rgba(255,255,255,0.5) 98%);
    border: 1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
    border-left: ${p => belowBreakpointOrEqual(p, "tablet") ? "1px solid " + getColor(p, p.theme.colors.middleLightGrey) : "none"};
    padding: ${p => belowBreakpointOrEqual(p, "tablet") ? 0 : "40px 26px 40px 26px"};
    position: relative;
    cursor: default;
    margin-top: ${p => belowBreakpointOrEqual(p, "tablet") ? "50px" : 0};
`;
    public static BackgroundFade = styled.div`
    position: absolute;
    height: 50px;
    top:0;
    left:0;
    width: 100%;
    background: rgba(255,255,255,0.5);
`;

    public static WikiQuizSlider = styled.div<{ homeView: boolean }>`
    width: 100%;
    height: ${p => belowBreakpointOrEqual(p, "tablet") ? aboveBreakpoint(p, "mobile") ? "230px" : "240px" : belowBreakpointOrEqual(p, "desktop") ? "240px" : "250px"};
    //margin-top: 20px;
    //background: ${p => fadeColor(p, getColor(p, p.theme.colors.mainBackground), 50)};
    border: 1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
    border-right: ${p => (belowBreakpointOrEqual(p, "tablet") || p.homeView) ? "1px solid " + getColor(p, p.theme.colors.middleLightGrey) : "none"};
    padding: 40px;
    position: relative;
    *:focus {
        outline: 0;
    }
    .slider-control-left{
        cursor: pointer;
        transition: all 0.2s ease-out;
        margin-left: ${p => belowBreakpointOrEqual(p, "tablet") ? 0 : "-15px"};
        margin-top: ${p => belowBreakpointOrEqual(p, "tablet") ? "-85px" : "-15px"};
        svg{
            stroke: ${p => belowBreakpointOrEqual(p, "tablet") ? getColor(p, p.theme.colors.veryLightGrey) : getColor(p, p.theme.colors.middleLightGrey)};
        &:hover{
            stroke: ${p => belowBreakpointOrEqual(p, "tablet") ? getColor(p, p.theme.colors.middleLightGrey) : getColor(p, p.theme.colors.lightGrey)};
        }
        }
    }
    .slider-control-right{
        cursor: pointer;
        transition: all 0.2s ease-out;
        margin-right: ${p => belowBreakpointOrEqual(p, "tablet") ? 0 : "-15px"};
        margin-top: ${p => belowBreakpointOrEqual(p, "tablet") ? "-85px" : "-15px"};
        svg{
            stroke: ${p => belowBreakpointOrEqual(p, "tablet") ? getColor(p, p.theme.colors.veryLightGrey) : getColor(p, p.theme.colors.middleLightGrey)};
        &:hover{
            stroke: ${p => belowBreakpointOrEqual(p, "tablet") ? getColor(p, p.theme.colors.middleLightGrey) : getColor(p, p.theme.colors.lightGrey)};
        }
        }
    }
    .slider-control-left-bottom{
        cursor: pointer;
        //margin-left: -15px;
        transition: all 0.2s ease-out;
        svg{
            stroke: ${p => belowBreakpointOrEqual(p, "mobile") ? getColor(p, p.theme.colors.mainForeground) : getColor(p, p.theme.colors.veryLightGrey)};
        &:hover{
            stroke: ${p => belowBreakpointOrEqual(p, "mobile") ? getColor(p, p.theme.colors.darkerGrey) : getColor(p, p.theme.colors.middleLightGrey)};
        }
        }
    }
    .slider-control-right-bottom{
        cursor: pointer;
        //margin-right: -16px;
        transition: all 0.2s ease-out;
        svg{
            stroke: ${p => belowBreakpointOrEqual(p, "mobile") ? getColor(p, p.theme.colors.mainForeground) : getColor(p, p.theme.colors.middleLightGrey)};
        &:hover{
            stroke: ${p => belowBreakpointOrEqual(p, "mobile") ? getColor(p, p.theme.colors.darkerGrey) : getColor(p, p.theme.colors.accent)};
        }
        }
    }
    .slider-control-bottomcenter {
        position: absolute;
        bottom: ${p => belowBreakpointOrEqual(p, "tablet") ? "10px" : 0};
        left: 50%;
        transform: translateX(-50%);

    ul {
        position: relative;
        top: -10px;
        display: flex;
        margin: 0px;
        padding: 0px;
        list-style-type: none;

        li {
            button {
                cursor: pointer;
                opacity: 1;
                background: transparent;
                border: none;
                fill: ${p => getColor(p, p.theme.colors.middleLightGrey)};
                padding: ${p => belowBreakpointOrEqual(p, "tablet") ? "1px 3px" : "1px 6px"};
                &:hover{
                    fill: ${p => getColor(p, p.theme.colors.lightGrey)};
                }
            }
        }
    }

    .active {
        button {
            fill: ${p => getColor(p, p.theme.colors.accent)}!important;
        }
    }
}

`;

    public static QuizHeader = styled.div`
    width: 100%;
    cursor: default;
    height: 50px;
    line-height:40px;
    font-size: 1.2rem;
    font-weight: bolder;
    padding-left:10px;
    padding-bottom:10px;
    margin-top: 40px;
    text-transform: capitalize;
    //border-bottom: 1px solid ${props => props.theme.colors.middleLightGrey};   
`;
    public static QuizHeaderMaster = styled.div`
    width: 100%;
    height: 50px;
    line-height:40px;
    font-size: 1.2rem;
    font-weight: bolder;
    padding-left:10px;
    padding-bottom:10px;
    margin-top: 40px;
    text-transform: capitalize;
    color: ${props => props.theme.colors.accent};  
    position: absolute;
    left: 0;
    top: -92px;
    cursor: default;
`;
    public static QuizHeaderMasterCategory = styled.div`
    width: 100%;
    font-size: 0.8rem;
    font-weight: bolder;
    padding-left:10px;
    padding-bottom:10px;
    margin-top: 40px;
    color: ${props => props.theme.colors.accent};  
    position: absolute;
    left: 26px;
    top: -65px;
    cursor: default;
`;
    public static WikiQuizSliderContainer = styled.div<{ homeView?: boolean, isMaster?: boolean, played: boolean }>`
    width: ${p => belowBreakpointOrEqual(p, "tablet") ? p.homeView ? "100%" : "50%" : "calc(100% - 1px)"};
    left: ${p => belowBreakpointOrEqual(p, "tablet") ? "50%" : "unset"};
    top: ${p => belowBreakpointOrEqual(p, "tablet") ? "50%" : "unset"};
    aspect-ratio: 16 / 9;
    background: ${p => getColor(p, p.theme.colors.mainBackground)};
    cursor: pointer;
    position: relative;
    transition: 0.2s all ease-out;
    transform-origin: center center;
    transform: translateY(${p => belowBreakpointOrEqual(p, "tablet") ? p.isMaster ? "-65%" : "-50%" : 0}) ${p => belowBreakpointOrEqual(p, "tablet") && "translateX(-50%);"};
    .play{
        transition: 0.3s all ease-in-out;
        position: absolute;
        width: ${p => belowBreakpointOrEqual(p, "tablet") ? "52.5px" : belowBreakpointOrEqual(p, "desktop") ? "52.5px" : "74px"};
        height: ${p => belowBreakpointOrEqual(p, "tablet") ? "52.5px" : belowBreakpointOrEqual(p, "desktop") ? "52.5px" : "74px"};
        left: 50%;    
        transform-origin: center center;
        border-radius: 37px;
        top: ${p => belowBreakpointOrEqual(p, "tablet") ? "47%" : belowBreakpointOrEqual(p, "desktop") ? "47%" : "50%"};
        box-shadow: 0 0 0 0 #FFF;

        padding-left: 3px;
        padding-top: 3px;
        transform: translate(-50%, -50%) scale(-1, -1);
        opacity: 0;
    }
    
    &:hover{
        img{
            filter: grayscale(1) brightness(0.6);
        }
        .play{
            box-shadow: rgba(255,255,255, 0.25) 0px 54px 55px, rgba(255,255,255, 0.9) 0px -12px 30px, rgba(255,255,255, 0.5) 0px 4px 6px, ${p => fadeColor(p, getColor(p, p.played ? p.theme.colors.accentGreen : p.theme.colors.accent), 20)} 0px 12px 13px, rgba(255,255,255, 0.2) 0px -3px 5px;
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
            }
    }
`;

    public static WikiQuizSliderImageHead = styled.div`
        position: absolute;
        color: transparent;
        top: -20px;
        left: 10px;
        height: 50px;
        width: auto;
        font-size: ${p => belowBreakpointOrEqual(p, "tablet") ? "42px" : belowBreakpointOrEqual(p, "desktop") ? "49px" : "70px"};
        font-weight: bold;
        -webkit-text-stroke : 0.5px ${p => getColor(p, p.theme.colors.middleLightGrey)};
        text-transform: capitalize;
`;
    public static WikiQuizSliderImageHeadMaster = styled.div<{ noHomeView: boolean }>`
        position: absolute;
        color: ${p => p.noHomeView ? getColor(p, p.theme.colors.accent) : getColor(p, p.theme.colors.middleLightGrey)};
        top: -20px;
        left: 10px;
        height: 50px;
        width: calc(100% - 9px);
        font-size: ${p => belowBreakpointOrEqual(p, "tablet") ? "42px" : belowBreakpointOrEqual(p, "desktop") ? "49px" : "70px"};
        font-weight: bold;
        cursor: default;
        //-webkit-text-stroke: 1px ${p => getColor(p, p.theme.colors.accent)};
`;
    public static WikiQuizSliderImage = styled.img`
    width: 100%;
    aspect-ratio: 16 / 9;
    position: absolute;
    top: 0px;
    left:0px;
    right: 0px;
    transition: 0.2s all ease-out;
    border: 1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
    padding: 5px;
    &:hover{
        filter: grayscale(1);
    }
`;
    public static WikiQuizSliderFill = styled.div`
    width: 100%;
    aspect-ratio: 16 / 9;
    position: absolute;
    top: 0px;
    left:0px;
    right: 0px;
    transition: 0.2s all ease-out;
    border: 1px solid ${p => getColor(p, p.theme.colors.veryLightGrey)};
    padding: 5px;
    &:hover{
        filter: grayscale(1);
    }
`;

    public static WikiQuizSliderTitle = styled.div<{ fillObject?: boolean, played: boolean }>`
    position: absolute;
    bottom: -35px;
    left: 0px;
    right: 0px;
    text-align: center;
    color: ${p => p.fillObject ? getColor(p, p.theme.colors.middleLightGrey) : getColor(p, p.theme.colors.darkerGrey)};
    background: ${p => getColor(p, p.theme.colors.mainBackground)};
    box-shadow: ${p => p.fillObject ? "0 4px 4px -5px" : "0 6px 4px -6px"} ${p => p.fillObject ? getColor(p, p.theme.colors.mainForeground) : p.played ? getColor(p, p.theme.colors.lightGrey) : getColor(p, p.theme.colors.accentBlack)};
    height: 40px;
    line-height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: ${p => belowBreakpointOrEqual(p, "desktop") ? "0.8em" : "0.9em"};
    text-transform: ${p => p.fillObject ? "none" : "uppercase"};
    letter-spacing: 0.1px;
    word-spacing: 2px;
    font-weight: ${p => p.fillObject ? 400 : 600};
    padding: 0 5px;
    border: 1px solid ${p => p.fillObject ? getColor(p, p.theme.colors.veryLightGrey) : getColor(p, p.theme.colors.middleLightGrey)};
    border-top: 1px solid ${p => getColor(p, p.theme.colors.mainBackground)};
    cursor: pointer;
`;
    public static WikiQuizSliderSeen = styled.div`
    position: absolute;
    top: ${p => belowBreakpointOrEqual(p, "tablet") ? "47%" : belowBreakpointOrEqual(p, "desktop") ? "47%" : "50%"};
    left: 50%;    
    transform: translate(-50%, -50%);
    width: ${p => belowBreakpointOrEqual(p, "tablet") ? "30px" : belowBreakpointOrEqual(p, "desktop") ? "30px" : "42px"};
    height: ${p => belowBreakpointOrEqual(p, "tablet") ? "30px" : belowBreakpointOrEqual(p, "desktop") ? "30px" : "42px"};
    svg{
        stroke-width: 4px !important;
    }
`;
    public static WikiQuizSliderSeenAlternative = styled.div`  
    position: absolute;    
    bottom: 10px;
    left: 10px;
    width: 35px;
    height: 35px;
    background: rgba(255,255,255,0.15);
    border-radius: 50%;
    text-align: center;
    svg{
        stroke-width: 3.5px !important;
    }
`;
    public static WikiQuizSliderSeenCircle = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;    
    transform: translate(-50%, -50%);
    width: ${p => belowBreakpointOrEqual(p, "tablet") ? "40px" : belowBreakpointOrEqual(p, "desktop") ? "40px" : "56px"};
    height: ${p => belowBreakpointOrEqual(p, "tablet") ? "40px" : belowBreakpointOrEqual(p, "desktop") ? "40px" : "56px"};
    border-radius: 50%;
    border: 5px solid ${p => getColor(p, p.theme.colors.accentGreen)};
    background: ${p => fadeColor(p, getColor(p, p.theme.colors.mainBackground), 60)};
    &::after{
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;    
        transform: translate(-50%, -50%);
        width: ${p => belowBreakpointOrEqual(p, "tablet") ? "45px" : belowBreakpointOrEqual(p, "desktop") ? "45px" : "63px"};
        height: ${p => belowBreakpointOrEqual(p, "tablet") ? "45px" : belowBreakpointOrEqual(p, "desktop") ? "45px" : "63px"};
        border-radius: 50%;
        border: 5px solid ${p => getColor(p, p.theme.colors.mainBackground)};
        background: transparent;
    }
`;
    public static WikiQuizSliderInfo = styled.div<{ played: boolean }>`
    position: absolute;
    width: 60px;
    height: 60px;
    padding: 5px;
    text-align: center;
    top: -1px;
    right: 0px;    
    font-size: 0.9em;
    color: ${p => p.played ? getColor(p, p.theme.colors.mainBackground) : getColor(p, p.theme.colors.accentBlack)} !important;
    background: linear-gradient(335deg, ${p => fadeColor(p, p.played ? getColor(p, p.theme.colors.accentGreen) : getColor(p, p.theme.colors.mainBackground), 80)} 20%, ${p => fadeColor(p, p.played ? getColor(p, p.theme.colors.accentGreen) : getColor(p, p.theme.colors.mainBackground), 100)} 80%, ${p => fadeColor(p, p.played ? getColor(p, p.theme.colors.accentGreen) : getColor(p, p.theme.colors.mainBackground), 80)} 100%);
    clip-path: polygon(60% 0, 100% 40%, 100% 100%, 100% 100%, 0 0, 0 0);    
`;
    public static WikiQuizSliderInfoShadow = styled.div`
    filter: drop-shadow(-2px 2px 4px ${p => fadeColor(p, getColor(p, p.theme.colors.mainForeground), 50)});
`;

    public static WikiQuizSliderInfoInsideFigure = styled.div`
    position: absolute;
    top: -9px;
    right: -9px;
    width: 60px;
    line-height: 60px;
    height: 60px;
    transform: rotate(45deg);
    display: grid;
    grid-template-columns: 1fr 2px 1fr;
`;
    public static WikiQuizSliderHeadMasterCategory = styled.div`
    font-size: ${p => belowBreakpointOrEqual(p, "tablet") ? "12px" : belowBreakpointOrEqual(p, "desktop") ? "12px" : "14px"};
    position: absolute;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    left: 0;
    top: 0;
    transform: translateY(${p => belowBreakpointOrEqual(p, "tablet") ? "-20px" : belowBreakpointOrEqual(p, "desktop") ? "-26px" : "-36px"});
`;
    public static WikiQuizSliderHeadMasterInfo = styled.div`
        font-size: 28px;
        font-size: ${p => belowBreakpointOrEqual(p, "tablet") ? "20px" : belowBreakpointOrEqual(p, "desktop") ? "20px" : "28px"};
        display: inline-block;
        transform: translateY(${p => belowBreakpointOrEqual(p, "tablet") ? "-8px" : belowBreakpointOrEqual(p, "desktop") ? "-11px" : "-29px"});
        text-transform: capitalize;
`;
    public static WikiQuizSliderHeadMasterInfoQuiz = styled.div`
    display: inline-block;
    text-transform: capitalize;
`;
    public static WikiQuizSliderHeadMasterInfoHome = styled.div`
    font-size: 28px;
    display: inline-block;
    transform: translateY(${p => belowBreakpointOrEqual(p, "tablet") ? "-8px" : belowBreakpointOrEqual(p, "desktop") ? "-11px" : "-17px"});
    text-transform: capitalize;
`;
    public static WikiQuizSliderHeadMasterInfoHomeQuiz = styled.div`
    display: inline-block;
    text-transform: capitalize;
`;
    public static WikiQuizGameContainer = styled.div`
    width: ${p => p.theme.content.width}px;
    height: ${p => p.theme.content.height}px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: ${props => getColor(props, props.theme.colors.mainBackground)};
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 800 800'%3E%3Cdefs%3E%3CradialGradient id='a' cx='400' cy='400' r='50%25' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='rgba(255,255,255,0.9)'/%3E%3Cstop offset='1' stop-color='rgba(255,255,255,1)'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='400' cy='400' r='70%25' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='rgba(204,204,204,0.4)'/%3E%3Cstop offset='1' stop-color='rgba(255,255,255,0.4)'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='url(%23a)' width='800' height='800'/%3E%3Cg fill-opacity='.8'%3E%3Cpath fill='url(%23b)' d='M998.7 439.2c1.7-26.5 1.7-52.7 0.1-78.5L401 399.9c0 0 0-0.1 0-0.1l587.6-116.9c-5.1-25.9-11.9-51.2-20.3-75.8L400.9 399.7c0 0 0-0.1 0-0.1l537.3-265c-11.6-23.5-24.8-46.2-39.3-67.9L400.8 399.5c0 0 0-0.1-0.1-0.1l450.4-395c-17.3-19.7-35.8-38.2-55.5-55.5l-395 450.4c0 0-0.1 0-0.1-0.1L733.4-99c-21.7-14.5-44.4-27.6-68-39.3l-265 537.4c0 0-0.1 0-0.1 0l192.6-567.4c-24.6-8.3-49.9-15.1-75.8-20.2L400.2 399c0 0-0.1 0-0.1 0l39.2-597.7c-26.5-1.7-52.7-1.7-78.5-0.1L399.9 399c0 0-0.1 0-0.1 0L282.9-188.6c-25.9 5.1-51.2 11.9-75.8 20.3l192.6 567.4c0 0-0.1 0-0.1 0l-265-537.3c-23.5 11.6-46.2 24.8-67.9 39.3l332.8 498.1c0 0-0.1 0-0.1 0.1L4.4-51.1C-15.3-33.9-33.8-15.3-51.1 4.4l450.4 395c0 0 0 0.1-0.1 0.1L-99 66.6c-14.5 21.7-27.6 44.4-39.3 68l537.4 265c0 0 0 0.1 0 0.1l-567.4-192.6c-8.3 24.6-15.1 49.9-20.2 75.8L399 399.8c0 0 0 0.1 0 0.1l-597.7-39.2c-1.7 26.5-1.7 52.7-0.1 78.5L399 400.1c0 0 0 0.1 0 0.1l-587.6 116.9c5.1 25.9 11.9 51.2 20.3 75.8l567.4-192.6c0 0 0 0.1 0 0.1l-537.3 265c11.6 23.5 24.8 46.2 39.3 67.9l498.1-332.8c0 0 0 0.1 0.1 0.1l-450.4 395c17.3 19.7 35.8 38.2 55.5 55.5l395-450.4c0 0 0.1 0 0.1 0.1L66.6 899c21.7 14.5 44.4 27.6 68 39.3l265-537.4c0 0 0.1 0 0.1 0L207.1 968.3c24.6 8.3 49.9 15.1 75.8 20.2L399.8 401c0 0 0.1 0 0.1 0l-39.2 597.7c26.5 1.7 52.7 1.7 78.5 0.1L400.1 401c0 0 0.1 0 0.1 0l116.9 587.6c25.9-5.1 51.2-11.9 75.8-20.3L400.3 400.9c0 0 0.1 0 0.1 0l265 537.3c23.5-11.6 46.2-24.8 67.9-39.3L400.5 400.8c0 0 0.1 0 0.1-0.1l395 450.4c19.7-17.3 38.2-35.8 55.5-55.5l-450.4-395c0 0 0-0.1 0.1-0.1L899 733.4c14.5-21.7 27.6-44.4 39.3-68l-537.4-265c0 0 0-0.1 0-0.1l567.4 192.6c8.3-24.6 15.1-49.9 20.2-75.8L401 400.2c0 0 0-0.1 0-0.1L998.7 439.2z'/%3E%3C/g%3E%3C/svg%3E"), linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 5%, rgba(255,255,255,0) 95%, rgba(255,255,255,1) 100%);
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    padding: 40px;
    //border-radius: 50px;
    //box-shadow: 0 0 8px 4px ${props => getColor(props, props.theme.colors.darkerGrey)};
`;
    public static WikiQuizGameGrid = styled.div`
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 535px 1fr;
    grid-template-rows: 60px 1fr 90px;
    margin: auto;
`;
    public static WikiQuizGameGridHeader = styled.div`
    grid-column: 2;
    grid-row: 1;
    position: relative;
    padding: 5px;
    border: 1px solid ${props => getColor(props, props.theme.colors.middleLightGrey)};
    border-bottom: none;
    background: ${props => fadeColor(props, getColor(props, props.theme.colors.mainBackground), 50)};
    backdrop-filter: blur(10px);
`;
    public static WikiQuizGameGridContent = styled.div`
    grid-column: 2;
    grid-row: 2;
    position: relative;
    border: 1px solid ${props => getColor(props, props.theme.colors.middleLightGrey)};
    border-top: none;
    border-bottom: none;
    background: ${props => fadeColor(props, getColor(props, props.theme.colors.mainBackground), 50)};
    backdrop-filter: blur(10px);
`;
    public static WikiQuizGameGridFooter = styled.div`
    grid-column: 2;
    grid-row: 3;
    padding-top: 10px;
    border: 1px solid ${props => getColor(props, props.theme.colors.middleLightGrey)};
    border-top: none;
    box-shadow: 0 6px 8px -6px ${props => getColor(props, props.theme.colors.mainForeground)};
    background: ${props => fadeColor(props, getColor(props, props.theme.colors.mainBackground), 50)};
    backdrop-filter: blur(10px);
`;
    public static WikiQuizGameGridHeaderQuestionIndicator = styled.div`
    position: absolute;
    left: 110px;
    top: 0;
    bottom:0;
    right: 55px;
`;
    public static WikiQuizGameGridContentTimeUpInfo = styled.div`
    position: absolute;
    left: 50%;
    bottom:10vh;
    transform: translateX(-50%);
`;

    public static WikiQuizSliderInfoNew = styled.div`
    position: absolute;
    width: 60px;
    height: 60px;
    padding: 5px;
    text-align: center;
    top: -1px;
    right: -1px;    
    color: ${p => getColor(p, p.theme.colors.mainBackground)} !important;
    background: linear-gradient(335deg, ${p => fadeColor(p, getColor(p, p.theme.colors.accent), 80)} 20%, ${p => fadeColor(p, getColor(p, p.theme.colors.accent), 100)} 80%, ${p => fadeColor(p, getColor(p, p.theme.colors.accent), 80)} 100%);
    clip-path: polygon(60% 0, 100% 40%, 100% 100%, 100% 100%, 0 0, 0 0);    
`;
    public static WikiQuizSliderInfoInsideFigureNew = styled.div`
    position: absolute;
    top: -6px;
    right: -9px;
    width: 60px;
    line-height: 60px;
    height: 60px;
    transform: rotate(45deg);
    display: grid;
    grid-template-columns: 1fr;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 0.75em;
`;
    public static WikiMasterQuizInfo = styled.div`
    padding: 0px 45px;
    line-height: 40px;
    text-align: left;
    color: ${p => getColor(p, p.theme.colors.darkerGrey)};
`;

    public static TransTableGrid = styled.div`
        border: 1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
        border-bottom: none;
        display: grid;
        grid-template-columns: 40px 100px 1fr 150px 150px 100px;
        grid-template-rows: 40px;
`;
    public static TransTableGridHeaderCell = styled.div`
        font-weight: bolder;
        //line-height: 40px;
        padding: 0 2px;
        align-content: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        button>div{margin:0;}
`;
    public static TransTableGridContentCell = styled.div`
        //line-height: 40px;
        padding: 0 4px;
        align-content: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        border-bottom: 1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
        transition: 0.2s all ease-out;
        div{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        }
`;
    public static TransTableGridContentCellWrapper = styled.div<{ even: boolean, selected: boolean }>`
        display: contents;
        & > div{
            background: ${p => p.even ? p.selected ? lightenColor(p, p.theme.colors.veryLightGrey, 94) : lightenColor(p, p.theme.colors.mainBackground, 98) : p.selected ? lightenColor(p, p.theme.colors.veryLightGrey, 96) : lightenColor(p, p.theme.colors.mainBackground, 100)};
            }
        &:hover > div{
            background: ${p => p.even ? p.selected ? lightenColor(p, p.theme.colors.veryLightGrey, 87) : lightenColor(p, p.theme.colors.mainBackground, 91) : p.selected ? lightenColor(p, p.theme.colors.veryLightGrey, 89) : lightenColor(p, p.theme.colors.mainBackground, 93)};
            }
        `;

    public static TransTable = styled.table`
    width: 100%;
    border: 1px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
    border-bottom: none;
`;
    public static TransTh = styled.th`
    height: 40px;
    line-height: 40px;
    text-align: left;
    border-bottom: 1px solid ${p => getColor(p, p.theme.colors.lightGrey)};
    padding: 0 10px;
    font-weight: bolder;
    button>div{
        margin: 0;
    }
    &:first-child {
        padding:0;
    }
    
`;
    public static TransTd = styled.td<{ showMore?: boolean, color?: string }>`
    height: 40px;
    line-height: 40px;
    text-align: left;
    border-bottom: ${p => p.showMore ? 0 : 1}px solid ${p => getColor(p, p.theme.colors.middleLightGrey)};
    padding: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${p => p.color ? getColor(p, p.color) : ""};
    &:first-child {
        padding:0;
    }
`;

    public static TransTr = styled.tr<{ even: boolean, selected: boolean, showMore?: boolean }>`
    background: ${p => p.even ? p.selected ? lightenColor(p, p.theme.colors.veryLightGrey, 94) : lightenColor(p, p.theme.colors.mainBackground, 98) : p.selected ? lightenColor(p, p.theme.colors.veryLightGrey, 96) : lightenColor(p, p.theme.colors.mainBackground, 100)};
    transition: 0.2s all ease-out;
    &:hover{
        background: ${p => p.showMore ? p.even ? p.selected ? lightenColor(p, p.theme.colors.veryLightGrey, 94) : lightenColor(p, p.theme.colors.mainBackground, 98) : p.selected ? lightenColor(p, p.theme.colors.veryLightGrey, 96) : lightenColor(p, p.theme.colors.mainBackground, 100) : p.even ? p.selected ? lightenColor(p, p.theme.colors.veryLightGrey, 92) : lightenColor(p, p.theme.colors.mainBackground, 96) : p.selected ? lightenColor(p, p.theme.colors.veryLightGrey, 94) : lightenColor(p, p.theme.colors.mainBackground, 98)};
    }
`;
    public static TransGrid = styled.div<{ backgroundColor?: string }>`
        min-height: 40px;
        display: grid;
        grid-template-columns: ${props => belowBreakpointOrEqual(props, "tablet") ? "1fr" : "max-content 1fr"}; 
        grid-template-rows: ${props => belowBreakpointOrEqual(props, "tablet") ? "min-content" : "min-content"}; 
        margin-bottom: 10px;
        background-color: ${p => p.backgroundColor ? getColor(p, p.backgroundColor) : ""};
`;
    public static TransLabel = styled.div<{ color?: string, closed?: boolean }>`
        color: ${p => p.color ? getColor(p, p.color) : ""};
        font-size:0.9rem;
        width: 100%;
        padding-right: 20px;
        padding-top: 10px;
        transition: 0.2s all ease-out;
        overflow: hidden;
        white-space: nowrap;
        height: ${p => p.closed ? 0 : 40}px;
        &::after {
        content: ":";
        }
`;
    public static TransMissingItem = styled.div`
        border-left: 3px solid ${p => getColor(p, p.theme.colors.accentRed)};
        padding-left: 10px;
        color:${p => getColor(p, p.theme.colors.accentRed)};
`;
    public static TableGridLegend = styled.div`
    width: 100%;
    padding-left: 5px;
    padding-bottom: 40px;
    line-height: 40px;
    z-index: 60;
    border-top: 1px solid ${p => getColor(p, p.theme.colors.lightGrey)};
    margin-top: -1px;
`;
}
